import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
import { BENEFITS_MODAL_FLOW } from 'dibs-buyer-layout/src/authModal/authentication/authFlowConstants';

import {abExperiments} from 'dibs-buyer-layout/src/entries/index';
import {AUTO} from '../../newPdp/components/MultiplePdpVisitsModal/multiplePdpVisitsModalConstants.es';
import {MODAL_TYPE as FOLLOW_SUGGESTION_TYPE} from './rules/followSuggestionModalRule.es';

export const benefitsModalTest = ({ modalType }) => {
    if (
        abExperiments.benefitsModal &&
        (modalType === AUTO || modalType === FOLLOW_SUGGESTION_TYPE)
    ) {
        setTimeout(function() {
            abExperiments.benefitsModal.reject();
        }, 800);

        return abExperiments.benefitsModal
            .then(() => {
                return Promise.resolve();
            })
            .catch(() => {
                return Promise.reject();
            });
    } else {
        return Promise.reject();
    }
};

export const benefitsModalShow = () => {
    return authModalLoader.show({
        action: authModalLoader.constants.REGISTER,
        flow: BENEFITS_MODAL_FLOW,
        ga: {
            label: 'pageview limit reached',
            value: 0,
        },
    });
};



// WEBPACK FOOTER //
// ./assets/js/global/notifications/benefitsModalHelper.es.js